var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSignature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 237",
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.317,
    height: 140,
    viewBox: "0 0 203.317 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eoghl8zuza"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6368",
    style: {
      fill: "none"
    },
    d: "M0 0h203.317v140H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s0nxfdy6ab"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 186",
    d: "M330.771 34.548a9.457 9.457 0 0 0 1.291 13.312 27.25 27.25 0 0 1 8.755 28.869 13.4 13.4 0 0 0-18.349 18.225 27.2 27.2 0 0 1-24.988-5.08 9.457 9.457 0 0 0-12.021 14.6A45.774 45.774 0 0 0 314.688 115q2.258 0 4.537-.221a45.871 45.871 0 0 0 21.737-7.919 10.047 10.047 0 1 0 11.7-11.683 46.124 46.124 0 0 0-8.575-61.915 9.456 9.456 0 0 0-13.312 1.292",
    transform: "translate(-282.012 -31.101)",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5c0ms345c",
    x1: -0.475,
    y1: 1.265,
    x2: -0.473,
    y2: 1.265,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#ffca44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc13d"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 232"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 231",
    style: {
      clipPath: "url(#eoghl8zuza)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 177",
    d: "M129.2 447.2a3.136 3.136 0 0 1-3.133-3.133v-23.644a3.132 3.132 0 1 1 6.265 0v23.647a3.136 3.136 0 0 1-3.132 3.13",
    transform: "translate(-93.033 -307.949)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 178",
    d: "M184.514 447.2a5.088 5.088 0 0 1-4.758-3.236l-8.765-22.184a3.285 3.285 0 0 1 3.055-4.492 3.3 3.3 0 0 1 3.081 2.145l7.686 20.772 7.712-20.938a3.037 3.037 0 0 1 2.839-1.979 3.025 3.025 0 0 1 2.813 4.137l-8.905 22.539a5.088 5.088 0 0 1-4.758 3.236",
    transform: "translate(-126.014 -307.949)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 179",
    d: "M302.452 445.74c-9.37 0-16.17-6.612-16.17-15.722s6.8-15.722 16.17-15.722 16.17 6.612 16.17 15.722-6.8 15.722-16.17 15.722m0-25.85c-5.739 0-9.9 4.26-9.9 10.129s4.166 10.129 9.9 10.129 9.9-4.26 9.9-10.129-4.166-10.129-9.9-10.129",
    transform: "translate(-211.269 -305.74)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 180",
    d: "M548.014 447.2a3.136 3.136 0 0 1-3.133-3.133v-6.232l-8.7-15.941a3.115 3.115 0 1 1 5.51-2.905l6.62 13 6.651-13.132a2.869 2.869 0 1 1 5.078 2.67l-8.9 16.3v6.232a3.136 3.136 0 0 1-3.133 3.133",
    transform: "translate(-395.406 -307.949)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 181",
    d: "M432.845 447.2a3.029 3.029 0 0 1-3.025-3.026V422.36a5.076 5.076 0 0 1 5.07-5.07h6.916c7.393 0 11.986 3.892 11.986 10.156a9.228 9.228 0 0 1-5.413 8.836l-.276.129 3.951 6.125a3.025 3.025 0 0 1-2.542 4.666h-.118a3.086 3.086 0 0 1-2.5-1.506l-6.794-11.055a1.655 1.655 0 0 1 1.409-2.521c3.826 0 6.02-1.7 6.02-4.675s-2.194-4.675-6.02-4.675h-4.622a.8.8 0 0 0-.8.8v20.6a3.029 3.029 0 0 1-3.025 3.026z",
    transform: "translate(-317.196 -307.949)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 182",
    d: "M24.347 447.583a3.3 3.3 0 0 1-3.081-2.145l-7.686-20.773L5.868 445.6a3.037 3.037 0 0 1-2.839 1.979 3.025 3.025 0 0 1-2.813-4.136l8.9-22.539a5.116 5.116 0 0 1 9.516 0L27.4 443.09a3.286 3.286 0 0 1-3.055 4.492",
    transform: "translate(0 -308.23)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 183",
    d: "M675.5 443.726c-8.775 0-15.144-6.612-15.144-15.722s6.369-15.722 15.144-15.722 15.143 6.612 15.143 15.722-6.369 15.722-15.143 15.722m0-25.85c-5.375 0-9.276 4.26-9.276 10.129s3.9 10.129 9.276 10.129 9.276-4.26 9.276-10.129-3.9-10.129-9.276-10.129",
    transform: "translate(-487.324 -304.254)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 184",
    d: "m746.2 504.189-2.485-3.289a3.061 3.061 0 0 1 4.884-3.689l2.484 3.289a3.061 3.061 0 0 1-4.884 3.689",
    transform: "translate(-548.387 -366.031)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 185",
    d: "M254.795 83.893a9.418 9.418 0 0 1-6.005-2.156A46.123 46.123 0 0 1 273.648.22a45.821 45.821 0 0 1 33.766 10.3 9.457 9.457 0 0 1-12.021 14.6 27.208 27.208 0 1 0-34.583 42.014 9.458 9.458 0 0 1-6.016 16.759",
    transform: "translate(-171.191)",
    style: {
      fill: "#008ded"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 234"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 233",
    style: {
      clipPath: "url(#s0nxfdy6ab)"
    },
    transform: "translate(73.895 8.149)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6369",
    transform: "rotate(-37.776 25.443 77.764)",
    style: {
      fill: "url(#i5c0ms345c)"
    },
    d: "M0 0h116.083v116.786H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 236"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 235",
    style: {
      clipPath: "url(#eoghl8zuza)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 187",
    d: "M476.662 46.591a9.446 9.446 0 1 1-1.29-13.3 9.446 9.446 0 0 1 1.29 13.3",
    transform: "translate(-339.41 -22.981)",
    style: {
      fill: "#17c3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 188",
    d: "M298.675 262.647a9.447 9.447 0 1 1-1.29-13.3 9.447 9.447 0 0 1 1.29 13.3",
    transform: "translate(-208.06 -182.424)",
    style: {
      fill: "#17c3b2"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSignature);
export default __webpack_public_path__ + "static/media/logo-signature.608ebdeb.svg";
export { ForwardRef as ReactComponent };